import React from "react";
import PropTypes from "prop-types";
// import { List, OrderedMap } from "immutable";
// import moment from "moment";
import { List as AntList, InputNumber, Card, Select, Button, message} from "antd";
import { PermissionContextManager, PermissionContextConsumer } from "hocs";
import { UI_PERMISSIONS } from "constants/index";
import { formatCurrency } from "utilities/index";
import { CompanyService } from "../../services";

const ListItem = AntList.Item;
const ListItemMeta = ListItem.Meta;
const Option = Select.Option;
class SalesData extends React.Component {
    state = {
        currentFinancialYear: null,
        currentFinancialYearId: null,
        sales_with_anchor: null,
        total_sales: 0,
        options: [],
    };
    onSalesDataChange = value =>
        this.setState({
            total_sales: value
        });
    // componentDidMount() {
    //     let financial_year_last_year, financial_year_first_year;
    //     financial_year_last_year = moment().year();
    //     financial_year_first_year = financial_year_last_year - 1;

    //     let financial_year_last_to_last_year = moment().year() - 1;
    //     let financial_year_last_to_first_year = financial_year_last_year - 2;
    //     let current_month = moment().month();
    //     let financial_options = [];
    //     if (current_month < 3) {
    //         financial_options = [
    //             financial_year_first_year + "-" + financial_year_last_year,
    //             financial_year_last_to_first_year +
    //                 "-" +
    //                 financial_year_last_to_last_year
    //         ];
    //     } else {
    //         financial_options = [
    //             financial_year_last_year + "-" + (financial_year_last_year + 1),
    //             financial_year_first_year + "-" + financial_year_last_year
    //         ];
    //     }
    //     this.setState({
    //         options: financial_options,
    //         currentFinancialYear: financial_options[0]
    //     });

    //     let selected_years = financial_options[0].split("-");

    //     this.getSalesData(
    //         parseInt(selected_years[0]),
    //         parseInt(selected_years[1])
    //     );
    // }

    componentDidMount() {
        this.setValues();
    }

    componentDidUpdate() {
        if (
            this.props.caseDetails &&
            !this.state.total_sales &&
            this.props.caseDetails.get("total_sales") !== null &&
            this.props.financial_years &&
            (this.props.financial_years.size > 0 ||
                this.props.financial_years.length > 0)
        ) {
            this.setValues();
        }
    }

    setValues = () => {
        if (
            !this.state.total_sales &&
            this.props.financial_years &&
            (this.props.financial_years.size > 0 ||
                this.props.financial_years.length > 0) &&
            this.props.caseDetails &&
            this.props.caseDetails.get("financial_year")
        ) {
            let financial_year = this.props.financial_years.find(
                _ => _.id === this.props.caseDetails.get("financial_year").id
            );
            this.setState({
                total_sales: this.props.caseDetails.get("total_sales"),
                currentFinancialYearId: this.props.caseDetails.get(
                    "financial_year"
                ).id,
                currentFinancialYear: financial_year.name
            });

            this.getSalesData(financial_year);
        }
    };

    getSalesData = financial_year => {
        if (
            this.props.financial_data &&
            this.props.financial_data.data.size > 0
        ) {
            const arrSum = this.props.financial_data.data
                .filter(_ => {
                    const date = Object.keys(_)[0];
                    if (
                        financial_year &&
                        financial_year.start_date &&
                        financial_year.start_date.isSameOrBefore(date) &&
                        financial_year.end_date.isAfter(date)
                    ) {
                        return true;
                    }
                    return false;
                })
                .reduce((agg, value) => agg + Object.values(value)[0], 0);

            // let sales_data_for_first_financial = this.props.financial_data
            //     .toJS()
            //     .find(_ => _.trade_year === financial_year_first_year);
            // let sales_data_for_last_financial = this.props.financial_data
            //     .toJS()
            //     .find(_ => _.trade_year === financial_year_last_year);
            // const first_three_months = ["Jan", "Feb", "Mar"];
            // sales_data_for_first_financial = sales_data_for_first_financial
            //     ? Object.keys(sales_data_for_first_financial).map(k => {
            //         if (
            //             !first_three_months.includes(k) &&
            //               !["trade_year", "total_sales"].includes(k)
            //         ) {
            //             return sales_data_for_first_financial[k];
            //         }
            //         return 0;
            //     })
            //     : null;
            // sales_data_for_last_financial = sales_data_for_last_financial
            //     ? Object.keys(sales_data_for_last_financial).map(k => {
            //         if (first_three_months.includes(k)) {
            //             return sales_data_for_last_financial[k];
            //         }
            //         return 0;
            //     })
            //     : null;
            // let arrSum = sales_data_for_first_financial
            //     ? sales_data_for_first_financial.reduce((a, b) => a + b, 0)
            //     : 0;
            // arrSum =
            //     arrSum +
            //     (sales_data_for_last_financial
            //         ? sales_data_for_last_financial.reduce((a, b) => a + b, 0)
            //         : 0);
            this.setState({
                sales_with_anchor: arrSum
            });
        }
    };

    selectFinancialYear = ({ val, id }) => {
        this.setState({
            currentFinancialYearId: parseInt(id),
            currentFinancialYear: val
        });
        const financial_year = this.props.financial_years.find(
            _ => _.id === parseInt(id)
        );
        this.getSalesData(financial_year);
    };

    updateLimit = () => {
        this.props.updateTotalSales(
            this.props.financial_years.find(
                _ => _.id === this.state.currentFinancialYearId
            ),
            this.state.total_sales
        );
    };

    yearWiseSorter = (a, b) => {
        const firstYear = a.start_date,
            secondYear = b.start_date;
        if (firstYear.isBefore(secondYear)) {
            return 1;
        }
        return -1;
    };
    render() {
        const total_sales_input = (
            <PermissionContextConsumer>
                {context =>
                    context.get("credit_appraisal_sales_data_edit") && this.props.isUserAllowedToEdit ? (
                        <InputNumber
                            value={this.state.total_sales}
                            onChange={this.onSalesDataChange}
                        />
                    ) : (
                        formatCurrency(this.state.total_sales, true)
                    )
                }
            </PermissionContextConsumer>
        );

        const dependencyVal = (this.state.total_sales && +this.state.total_sales > 0
            ? (
                (+this.state.sales_with_anchor /
                      +this.state.total_sales) *
                  100
            ).toFixed(2)
            : 0);

        const dependencyOnAnchor = (
            <PermissionContextConsumer>
                {context => 
                    context.get("credit_appraisal_sales_data_edit") && this.props.isUserAllowedToEdit ? (
                        <InputNumber
                            value={dependencyVal}
                        />
                    ) :
                        (
                            dependencyVal + "%"
                        )
                }
            </PermissionContextConsumer>
        );
        const downloadSalesData = (gstin) => {
            CompanyService.getGstinConsent(gstin).then(res => {
                const fileUrl = res.data && res.data[0] && res.data[0].doc_url;
                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', 'gstin_file_name'); // Set desired file name here
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }else{
                    message.error("GSTIN data not found");
                }
            }).catch(error => {
                // message.error("GSTIN data not found");
            })
        }
        const retailerGstin = this.props.companyDetail?.gstin;
        const sellerGstin = this.props.caseDetails?.supply_chains[0] && this.props.caseDetails?.supply_chains[0]?.seller.gstin;
        return (
            <Card
                title={"Sales Data"}
                className={"padless-card small-card-title"}
                extra={
                    <div>
                    <Button className={"ant-btn ant-btn-primary mr-2"} onClick={()=>downloadSalesData(retailerGstin)}>Retailer Gstin</Button>
                    <Button className={"ant-btn ant-btn-primary mr-2"} onClick={()=>downloadSalesData(sellerGstin)}>Seller Gstin</Button>
                    {this.props.SALES_DATA_EDIT && this.props.isUserAllowedToEdit ?
                         [
                            <React.Fragment key="fragment">
                                <Select
                                    key="select-financial-year"
                                    style={{ width: 200, marginRight: "0.5rem" }}
                                    onSelect={this.selectFinancialYear}
                                    value={this.state.currentFinancialYear}
                                    placeholder={"Select Financial Year"}
                                    size={"small"}
                                >
                                    {this.props.financial_years
                                        .sort(this.yearWiseSorter)
                                        .map(_ => (
                                            <Option
                                                key={_.id}
                                                value={{
                                                    val: _.name,
                                                    id: String(_.id)
                                                }}
                                            >
                                                {_.name}
                                            </Option>
                                        ))}
                                </Select>
                                <a
                                    key="update-link"
                                    onClick={this.updateLimit}
                                    disabled={this.props.recreditViewOnlyPermission}
                                >
                                    {" "}
                                      Update
                                </a>
                            </React.Fragment>
                         ] 
                         : []}
                    </div>
                }
            >
                <AntList itemLayout="horizontal" size={"small"} className={"p-5"}>
                    <ListItem>
                        <ListItemMeta
                            title={`Sales with Anchor(${
                                this.state.currentFinancialYear || ""
                            })`}
                        />
                        <div>{formatCurrency(this.state.sales_with_anchor, true)}</div>
                    </ListItem>
                    <ListItem>
                        <ListItemMeta
                            title={`Total Sales (${
                                this.state.currentFinancialYear || ""
                            })`}
                        />
                        {/* <InputNumber onChange={this.onSalesDataChange} /> */}
                        {total_sales_input}
                    </ListItem>
                    <ListItem>
                        <ListItemMeta title={"Dependency on Anchor(%)"} />
                        {dependencyOnAnchor}
                    </ListItem>
                </AntList>
            </Card>
        );
    }
}

SalesData.propTypes = {
    data: PropTypes.object,
    handleProposedLimit: PropTypes.func,
    financial_data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    SALES_DATA_EDIT: PropTypes.bool,
    updateTotalSales: PropTypes.func,
    financial_years: PropTypes.object,
    caseDetails: PropTypes.object,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.SALES_DATA_VIEW,
    propsPermissions: {
        SALES_DATA_EDIT: UI_PERMISSIONS.SALES_DATA_EDIT
    }
})(SalesData);
